import type { Routes } from '@angular/router';
import { LoginComponent } from './features/login/login.component';
import { authGuard } from './core/auth/guard/auth.guard';
import { AuthenticatedShellComponent } from './core/auth/authenticated-shell.component';
import { guestGuard } from './core/auth/guard/guest.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [guestGuard],
  },
  {
    path: '',
    component: AuthenticatedShellComponent,
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard/dashboard.component'),
      },
      {
        path: 'projects',
        data: { breadcrumb: 'features.project.list.title' },
        loadChildren: () => import('./features/project/project.routes'),
      },
      {
        path: 'assist-devices',
        data: { breadcrumb: 'features.assistDevice.list.title' },
        loadChildren: () => import('./features/assist-device/assist-device.routes'),
      },
      {
        path: 'staff-monitor',
        data: { breadcrumb: 'features.staffMonitor.title' },
        loadComponent: () => import('./features/staff-monitor/staff-monitor.component'),
      },
      {
        path: 'marker-templates',
        data: { breadcrumb: 'features.markerTemplates.title' },
        loadComponent: () => import('./features/marker-template/marker-template.component'),
      },
      {
        path: '**',
        loadComponent: () => import('./features/page-not-found/page-not-found.component'),
      },
    ],
  },
];
